import React from 'react';
import { openCookiePreferences } from '../lib/analytics';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail } from 'lucide-react';

const Footer = () => {
    return (
        <footer className="bg-background border-t border-border py-16 transition-colors duration-300">
            <div className="max-w-7xl mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">

                    {/* Brand */}
                    <div className="col-span-1 md:col-span-2">
                        <h3 className="text-2xl font-light tracking-wider text-[#CEAC8F] mb-4">
                            MAISON D'OUD
                        </h3>
                        <p className="text-muted-foreground text-sm leading-relaxed max-w-md">
                            Refined perfume oils created for presence in absence — designed to be remembered long after you have left.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="text-foreground font-medium mb-4 text-sm tracking-wide">
                            Quick Links
                        </h4>
                        <ul className="space-y-2">
                            <li>
                                <Link to="/scents" className="text-muted-foreground hover:text-[#CEAC8F] text-sm transition-colors">
                                    Our Scents
                                </Link>
                            </li>
                            {/*<li>
                                <Link to="/team" className="text-muted-foreground hover:text-[#CEAC8F] text-sm transition-colors">
                                    The Team
                                </Link>
                            </li>*/}
                            <li>
                                <Link to="/contact" className="text-muted-foreground hover:text-[#CEAC8F] text-sm transition-colors">
                                    Get in Touch
                                </Link>
                            </li>
                            <li>
                                <Link to="/faq" className="text-muted-foreground hover:text-[#CEAC8F] text-sm transition-colors">
                                    FAQ
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Policies */}
                    <div>
                        <h4 className="text-foreground font-medium mb-4 text-sm tracking-wide">
                            Policies
                        </h4>
                        <ul className="space-y-2">
                            <li>
                                <Link to="/shipping" className="text-muted-foreground hover:text-[#CEAC8F] text-sm transition-colors">
                                    Shipping Policy
                                </Link>
                            </li>
                            <li>
                                <Link to="/refunds" className="text-muted-foreground hover:text-[#CEAC8F] text-sm transition-colors">
                                    Return & Exchanges
                                </Link>
                            </li>
                            <li>
                                <Link to="/terms" className="text-muted-foreground hover:text-[#CEAC8F] text-sm transition-colors">
                                    Terms & Conditions
                                </Link>
                            </li>
                            <li>
                                <Link to="/privacy" className="text-muted-foreground hover:text-[#CEAC8F] text-sm transition-colors">
                                    Privacy Policy
                                </Link>
                            </li>
                            <li>
                                <button
                                    type="button"
                                    onClick={openCookiePreferences}
                                    className="text-muted-foreground hover:text-[#CEAC8F] text-sm transition-colors"
                                >
                                    Cookie Settings
                                </button>
                            </li>
                            <li>
                                <Link to="/legal" className="text-muted-foreground hover:text-[#CEAC8F] text-sm transition-colors">
                                    Legal Notice
                                </Link>
                            </li>
                        </ul>
                    </div>

                </div>

                {/* Bottom */}
                <div className="pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-6">
                    <p className="text-muted-foreground text-sm">
                        © {new Date().getFullYear()} MAISON D'OUD. All rights reserved.
                    </p>
                    <div className="flex items-center gap-6">
                        <p className="text-muted-foreground text-sm">support@maisondoud.com</p>
                        <div className="flex gap-4">
                            <a
                                href="https://www.instagram.com/maisondoudofficial"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-muted-foreground hover:text-[#CEAC8F] transition-colors"
                                aria-label="Maison D'Oud on Instagram"
                            >
                                <Instagram className="w-5 h-5" />
                            </a>
                            <a href="#" className="text-muted-foreground hover:text-[#CEAC8F] transition-colors" aria-label="Maison D'Oud on Facebook">
                                <Facebook className="w-5 h-5" />
                            </a>
                            <a href="mailto:support@maisondoud.com" className="text-muted-foreground hover:text-[#CEAC8F] transition-colors" aria-label="Email support@maisondoud.com">
                                <Mail className="w-5 h-5" />
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </footer>
    );
};

export default Footer;